import Head from "next/head"

const MetaTags = ({title, image, description, url, type, canonicalUrl,
  imageAlt, imageWidth, imageHeight, siteName, locale = "en_US", structuredData}) => {
  const metaDescription = description || "The social publishing site for news";

  return (
    <Head>
      <meta charSet="utf-8"/>
      <meta name="theme-color" content="#000000"/>
      <meta name="description" content={metaDescription}/>
      <title>{title}</title>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:type" content={type || "website"}/>
      <meta property="og:locale" content={locale}/>
      {siteName && <meta property="og:site_name" content={siteName} />}
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={title}/>
      <meta name="twitter:description" content={metaDescription}/>
      <meta name="twitter:image" content={image}/>
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      <meta property="og:url" content={url || "https://www.bonjourno.com"}/>
      <meta property="og:title" content={title}/>
      <meta property="og:description" content={metaDescription}/>
      <meta property="og:image" content={image}/>
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      {imageWidth && <meta property="og:image:width" content={imageWidth} />}
      {imageHeight && <meta property="og:image:height" content={imageHeight} />}
      {structuredData && <script key="public-site-structured-data" type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData).replace(/</g, "\\u003c") }} />}
    </Head>
  )
}

export default MetaTags
